<script setup lang="ts">
</script>

<template>
  <p class="text-sm mb-4">
    <slot></slot>
  </p>
</template>
